'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index$1 = require('../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var React = require('react');
var NoStyleButton_web = require('../../atoms/NoStyleButton/NoStyleButton.web.cjs');
var Typography_web = require('../../atoms/Typography/Typography.web.cjs');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var Message_web_styles = require('./Message.web.styles.cjs');
var index = require('../../../../../../node_modules/motion/node_modules/framer-motion/dist/es/components/AnimatePresence/index.cjs');
var proxy = require('../../../../../../node_modules/motion/node_modules/framer-motion/dist/es/render/components/motion/proxy.cjs');

/**
 * Message component used to display messages to the user
 *
 *  {@link https://aviary.fullscript.io/latest/components/message/web-bT4moxHj | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/Message/Message.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Message = ({ title, label, intention = "neutral", onDismiss, children, ...rest })=>{
    const currentTheme = react.useTheme();
    const [isDismissed, setIsDismissed] = React.useState(false);
    const messageStyles = React.useMemo(()=>[
            Message_web_styles.messageBase,
            Message_web_styles.intention(currentTheme, intention)
        ], [
        currentTheme,
        intention
    ]);
    const handleDismiss = ()=>{
        onDismiss?.();
        setIsDismissed(true);
    };
    const renderIcon = ()=>{
        switch(intention){
            case "success":
                return index$1.faCheckCircle;
            case "info":
                return index$1.faQuestionCircle;
            case "warning":
                return index$1.faExclamationTriangle;
            case "critical":
                return index$1.faExclamationCircle;
            default:
                return index$1.faInfoCircle;
        }
    };
    const renderMessage = ()=>/*#__PURE__*/ jsxRuntime.jsx("div", {
            css: messageStyles,
            "data-testid": "aviary-message",
            ...rest,
            children: /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: Message_web_styles.contentWrapper,
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("div", {
                        children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                            icon: renderIcon(),
                            css: Message_web_styles.intentionIcon(currentTheme, intention),
                            color: currentTheme.ds5.message[intention].icon
                        })
                    }),
                    /*#__PURE__*/ jsxRuntime.jsxs("div", {
                        css: Message_web_styles.content,
                        children: [
                            !!title && /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                                variant: "body",
                                fontWeight: "bold",
                                customCss: Message_web_styles.title(currentTheme, intention),
                                children: title
                            }),
                            /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                                customCss: Message_web_styles.intentionText(currentTheme, intention),
                                children: label
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("div", {
                        children: /*#__PURE__*/ jsxRuntime.jsx(NoStyleButton_web.NoStyleButton, {
                            "aria-label": `Dismiss ${title} message`,
                            onClick: handleDismiss,
                            customCss: Message_web_styles.dismissButton,
                            children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                                icon: index$1.faTimes,
                                color: currentTheme.ds5.message.neutral.icon
                            })
                        })
                    })
                ]
            })
        });
    return /*#__PURE__*/ jsxRuntime.jsx(index.AnimatePresence, {
        children: !isDismissed && /*#__PURE__*/ jsxRuntime.jsx(proxy.motion.div, {
            animate: {
                opacity: 1,
                scale: 1
            },
            exit: {
                opacity: 0,
                scale: 0.95
            },
            transition: {
                duration: 0.4,
                ease: [
                    0.4,
                    0.0,
                    0.2,
                    1
                ]
            },
            children: renderMessage()
        })
    });
};

exports.Message = Message;
//# sourceMappingURL=Message.web.cjs.map
